module.exports = __webpack_public_path__ + "img/france.18a08201.png";